import { parsedGetCompanySchema } from "waapi/slaapi/Parser/parseGetCompany/schemas.js";
import z from "zod";

export const phoneNumberSchema = z.object({
    type: z.string(),
    number: z.string(),
    $type: z.string().optional(),
});
export type PhoneNumber = z.infer<typeof phoneNumberSchema>;
export const languageDataSchema = z.object({
    lang: z.string(),
});
export type LanguageData = z.infer<typeof languageDataSchema>;
export const contactDataSchema = z.object({
    birthday: z
        .object({
            month: z.number(),
            day: z.number(),
        })
        .optional(),
    address: z.string().optional(),
    connectedAt: z.number().optional(),
    email: z.string(),
    phoneNumbers: z.array(phoneNumberSchema),
});
export type ContactData = z.infer<typeof contactDataSchema>;
export const miniProfileSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    occupation: z.string(),
    publicIdentifier: z.string(),
    memberId: z.string(),
    profilePicture: z.string(),
});
export type MiniProfile = z.infer<typeof miniProfileSchema>;
export const miniCompanySchema = z.object({
    name: z.string(),
    urn: z.string(),
    logo: z.string(),
});
export type MiniCompany = z.infer<typeof miniCompanySchema>;
export const meDataSchema = miniProfileSchema.extend({
    linkedinId: z.number(),
    isPremiumSubscriber: z.boolean(),
    hasPasswordRecoverySetting: z.boolean(),
});
export type MeData = z.infer<typeof meDataSchema>;
export const linkedinAuthUserSchema = meDataSchema.and(contactDataSchema).and(
    z.object({
        company: parsedGetCompanySchema.partial().optional(),
        isRecruiter: z.boolean(),
    }),
);
export type LinkedinAuthUser = z.infer<typeof linkedinAuthUserSchema>;
